/*
 *==================================================
 * Licensed Materials - ADIACENT
 *
 * CR022 Autodesk Vault - CAD Download Basket
 *
 *==================================================
 */
//Standard libraries
import { createAction } from "@reduxjs/toolkit";
//Redux
import * as ACTIONTYPES from "../action-types/cadBasket";

export const CAD_BASKET_GET_REQUESTED_ACTION = createAction<any, string>(
  ACTIONTYPES.CAD_BASKET_GET_REQUESTED
);

export const CAD_BASKET_GET_SUCCESS_ACTION = createAction<any, string>(
  ACTIONTYPES.CAD_BASKET_GET_SUCCESS
);

export const CAD_BASKET_GET_ERROR_ACTION = createAction<any, string>(
  ACTIONTYPES.CAD_BASKET_GET_ERROR
);

export const CAD_BASKET_ADD_ITEM_REQUESTED_ACTION = createAction<any, string>(
  ACTIONTYPES.CAD_BASKET_ADD_ITEM_REQUESTED
);

export const CAD_BASKET_REMOVE_ITEM_REQUESTED_ACTION = createAction<any, string>(
  ACTIONTYPES.CAD_BASKET_REMOVE_ITEM_REQUESTED
);

export const CAD_BASKET_EMPTY_REQUESTED_ACTION = createAction<any, string>(
  ACTIONTYPES.CAD_BASKET_EMPTY_REQUESTED
);

export const CAD_BASKET_ZIP_REQUESTED_ACTION = createAction<any, string>(
  ACTIONTYPES.CAD_BASKET_ZIP_REQUESTED
);

export const CAD_BASKET_ZIP_SUCCESS_ACTION = createAction<any, string>(
  ACTIONTYPES.CAD_BASKET_ZIP_SUCCESS
);

export const CAD_BASKET_ZIP_MESSAGE_RESET_ACTION = createAction<any, string>(
  ACTIONTYPES.CAD_BASKET_ZIP_MESSAGE_RESET
);

export const CAD_BASKET_RESET_ACTION = createAction<any, string>(
  ACTIONTYPES.CAD_BASKET_RESET
);

export const CAD_PDP_EXCLUSION_TOGGLE_ACTION = createAction<any, string>(
  ACTIONTYPES.CAD_PDP_EXCLUSION_TOGGLE
);

export const CAD_PDP_EXCLUSIONS_RESET_ACTION = createAction<any, string>(
  ACTIONTYPES.CAD_PDP_EXCLUSIONS_RESET
);
